const alphabet = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ";

const encryptWord = (word: string, key: number): number[] => {
  return word
    .toUpperCase()
    .split("")
    .map((letter) => {
      const letterNumber = alphabet.indexOf(letter) + 1;

      if (letterNumber === 0) {
        throw new Error(`Неизвестная буква: ${letter}`);
      }

      return ((letterNumber - 1 - key + alphabet.length) % alphabet.length) + 1;
    });
};
export default encryptWord;
